export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_84fe975c-192f-4302-b7ba-0a888de2cc26/artifacts/dpfzb5vn_file_000000000af861f5b5e423b413fd2586.png";

export const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_84fe975c-192f-4302-b7ba-0a888de2cc26/artifacts/sdgupx9c_Repairing-Your-Electric-Scooter-1024x684.jpg";

export const FEATURE_IMG_TYRE =
  "https://customer-assets.emergentagent.com/job_84fe975c-192f-4302-b7ba-0a888de2cc26/artifacts/essqfrdd_install_tire_back_on_the_varla_scooter2.jpg";

export const FEATURE_IMG_MOBILITY =
  "https://customer-assets.emergentagent.com/job_84fe975c-192f-4302-b7ba-0a888de2cc26/artifacts/hewcunrl_md-mobility-servicing-repairs_orig.jpg";

export const SERVICE_TYPES = [
  { value: "tyre", label: "Tyre / Wheel" },
  { value: "brakes", label: "Brakes" },
  { value: "electrical", label: "Electrical / Battery" },
  { value: "general", label: "General Service" },
  { value: "unsure", label: "Not sure" },
];

export const URGENCY_LEVELS = [
  { value: "low", label: "Low — within 2 weeks", colour: "#10B981" },
  { value: "medium", label: "Medium — within 1 week", colour: "#F59E0B" },
  { value: "high", label: "High — ASAP", colour: "#EF4444" },
];

export const STATUS_FLOW = [
  "New",
  "Awaiting Drop-off",
  "Received",
  "Awaiting Quote Approval",
  "In Progress",
  "Long-Term Project",
  "Waiting on Parts",
  "Ready for Pickup",
  "Completed",
];

export const STATUS_COLOURS = {
  "New": "#FFD93D",
  "Awaiting Drop-off": "#0EA5E9",
  "Received": "#8B5CF6",
  "Awaiting Quote Approval": "#EC4899",
  "In Progress": "#178B8E",
  "Long-Term Project": "#6366F1",
  "Waiting on Parts": "#F97316",
  "Ready for Pickup": "#10B981",
  "Completed": "#0F172A",
  "Cancelled": "#94A3B8",
};

export const PAYMENT_STATUSES = ["Unpaid", "Partial", "Paid"];
